'use strict'

import $ from 'jquery';
import '../../../core/app/main';

// css
import '../../../core/app/plugins/bootstrap/bootstrap.css';
import '../../../core/app/modules/shared/styles/main.less';
import '../../../analytics/app/modules/shared/styles/app.less';

import 'angular-bootstrap-calendar/dist/css/angular-bootstrap-calendar.min.css';
import 'textangular/src/textAngular.css';
import 'angular-bootstrap-colorpicker/css/colorpicker.min.css';
import '../styles/main.less';
import '../styles/buySheet.css';
import '../modules/steps/styles/steps.css';
import '../styles/emoji.css';
import '../styles/select.css';


/* Node modules */
import angular from 'angular';
import 'angular-ui-router';
import 'angular-loading-bar';
import 'angular-sanitize';
import 'angular-animate';
import 'restangular';
import 'angular-ui-sortable';
import _ from 'lodash';
import 'angular-summernote/dist/angular-summernote';
import 'ng-file-upload';
import 'ng-img-crop/compile/unminified/ng-img-crop';
import 'angularjs-slider';
import 'angular-ui-bootstrap';
import 'angular-ui-sortable';
import 'angular-bootstrap-calendar';
import 'angular-utils-pagination';
import 'angular-bootstrap-colorpicker';
import 'textangular/dist/textAngular-rangy.min';
import 'textangular/dist/textAngular-sanitize.min';
import 'textangular/dist/textAngular.min';
import 'ment.io/dist/mentio';
import 'angular-gettext';

// gloabal.js
import './globals';


// Custom modules
import './shared/app.modules';
import './views/index';
import './shared/app.ctrls';
import './shared/app.directives';
import './shared/app.filters';
import '../modules/adgroup/adgroup.components';
import '../modules/dfp/dfp.components';
import '../modules/audienceTargeting/audienceTargeting.component';
import '../modules/dfpFrequencyCap/frequencyCap.components';
import '../modules/devices/devices.components';
import '../modules/adUnits/adUnits.components';
import '../modules/dayPartingTargeting/dayParting.component';
import '../modules/connection/connections.components';
import '../modules/multipleMappingsWidget/multiMappingsList.component';
import '../modules/mobileApp/mobileApp.component'
import '../modules/deviceCapability/deviceCapability.component';
import '../modules/inventoryFilter/inventoryFilter.component';
import '../modules/adSchedule/adSchedule.component';
import '../modules/shoppingAdgroupSingleProduct/shoppingAdgroupSingleProduct.components';
import '../modules/shoppingAdgroupMultiproduct/shoppingAdgroupMultiproduct.components';
import '../modules/facebookAdsLocations/facebookAdsLocations.component';
import '../modules/snapchatAdsLocation/snapchatAdsLocations.component'
import '../modules/xandrInvestLocations/xandrInvestLocations.component';
import '../modules/facebookAdsFrequency/facebookAdsFrequency.component';
import '../modules/pinterestAdsFrequency/pinterestAdsFrequency.component';
import '../modules/ageTargetingFb/ageTargeting.component';
import '../modules/snapChatAgeTargeting/snapChatAgeTargeting.component';
import '../modules/facebookCreateAds/facebookCreateAds.component';
import '../modules/geoTargetingGoogle/geoTargetingGoogle.component';
import '../modules/metricSelect/metricSelect.component';
import '../modules/contentLinks/contentLinks.component';
import '../modules/bridgeEmailTest/bridgeEmailTest.component'
import '../modules/googleAdsBidding/googleAdsBidding.component';
import '../modules/facebookAudienceTargeting/facebookAudience.component';
import '../modules/snapGender/snapGender.component';
import '../modules/advancedDemographics/advancedDemographics.component';
import '../modules/googleAdsExtension/googleAdsExtension.component';
import '../modules/pinterestAudienceTargeting/pinterestAudience.component';
import '../modules/snapChatFrequency/snapChatFrequency.component';
import '../modules/xandrInvestFrequency/xandrInvestFrequency.component';
import '../modules/tritonAdsFrequency/tritonAdsFrequency.component';
import '../modules/tritonTeams/tritonTeams.component';
import '../modules/yelpCategories/yelpCategories.component';
import '../modules/linkedinAudienceTargeting/linkedinAudience.component';
import '../modules/snapPredefinedAudiences/snapPredefinedAudiences.component';
import '../modules/customMacroMapping/customMacros.component';
import '../modules/customMacroMapping2/customMacros2.component';
import '../modules/seedListMacros/seedListMacros.component';
import '../modules/posMatchbackDetails/posMatchbackDetails.component';
import '../modules/tiktokAudienceTargeting/tiktokAudience.component';
import '../modules/tiktokDeviceTargeting/tiktokDevice.component';
import '../modules/tiktokLanguagesTargeting/tiktokLanguages.component';
import '../modules/imageUpload/imageUpload.component';
import '../modules/linksAndMainCta/linksAndMainCta.component';
import '../modules/facebookAudiences/facebookAudiences.component';
import '../modules/finalApproval/finalApproval.component';
import '../modules/googleAdManagerAvailUnits/googleAdManagerAvailUnits.component';
import '../modules/pinterestGeoLocation/pinterestGeoLocation.component';
import '../modules/facebookPageId/facebookPageId.component';
import '../modules/tritonListenerTargeting/tritonListenerTargeting.component';
import '../modules/tritonGeoTargeting/tritonGeo.component';
import '../modules/tritonCreativeManagement/tritonCreativeManagement.component';
import '../modules/linkedinGeoTargeting/linkedinGeo.component';
import '../modules/tritonTimeTargeting/tritonTimeTargeting.component';
import '../modules/tritonContentTargeting/tritonContentTargeting.component';
import '../modules/pinterestKeywords/pinterestKeyword.component';
import '../modules/snapchatPixels/snapchatPixels.component';
import '../modules/accountabilityGroupLabel/accountabilityGroupLabel.component';
import '../modules/linkedinAdsCampaignObjective/linkedinCampaignObjective.component';
import '../modules/tiktokAdsLocation/tiktokAdsGeoLocation.component';
// Core shared module
import '../../../core/app/modules/shared/core.shared.module';
// Plugins
import 'script-loader!./plugins/schema-form/tv4';
import 'script-loader!./plugins/schema-form/ObjectPath';
import 'script-loader!./plugins/schema-form/schema-form';
import 'script-loader!./plugins/graph-editor/js/mxClient';
import 'script-loader!./plugins/select';
import './plugins/schema-form/bootstrap-decorator.min';
import './plugins/schema-form/bootstrap-ui-select';
import './plugins/angular-translate';
import './plugins/ng-infinite-scroll/build/ng-infinite-scroll';
import './plugins/emoticons/config';
import './plugins/emoticons/util';
import './plugins/emoticons/jquery.emojiarea';
import './plugins/emoticons/tether.min';
import './plugins/emoticons/nanoscroller.min';
import './plugins/emoticons/emoji-picker';
import './plugins/multiLocationPicker';
import './plugins/multiLocationPickerFb'
import './plugins/dropbox';

import DevTools from '../../../core/app/devtools';
import dirPaginationTplHtmlUrl from 'ioToolViews/shared/dirPagination.tpl.html';
import layoutHtmlUrl from '../views/layout.html';
import appHeaderUrl from '../views/shared/header.html';
import './shared/tableExport';
import './shared/jquery.base64';
import './shared/appOverrides';
import peopleMentionsHtmlUrl from 'ioToolViews/directives/peopleMentions.html';
import oAuth from "../../../core/app/oauth";

const Main = $.core.main;

angular.module('app', [
    /* Angular modules */
    'ui.router',
    'angular-loading-bar',
    'ngSanitize',
    'ngAnimate',
    'restangular',

    /* Custom Modules */
    'app.ctrls',
    'app.directives',
    'app.services',
    'app.filters',
    'app.modules',
    'app.components',
    'app.dfpComponent',
    'audience.targeting.component',
    'app.frequencyCapComponent',
    'devices.component',
    'app.adUnitsComponent',
    'app.dayParting',
    'app.inventoryFilterComponent',
    'connections.component',
    'mobileApp.component',
    'app.multiMappingList.Component',
    'deviceCapability.component',
    'app.adSchedule',
    'app.shoppingAdgroupSingleProductComponents',
    'app.shoppingAdgroupMultiproductComponents',
    'app.facebookAdsLocations.component',
    'app.snapchatAdsLocations.component',
    'app.xandrInvestLocations.component',
    'app.metricSelect',
    'app.contentLinks',
    'app.bridgeEmailTest',

    'app.facebookAdsFrequencyComponent',
    'app.snapChatFrequencyComponent',
    'app.xandrInvestFrequencyComponent',
    'app.pinterestAdsFrequencyComponent',
    'app.ageTargetingFbComponent',
    'app.snapChatAgeTargetingComponent',
    'app.facebookCreateAdsComponent',
    'app.geoTargetingGoogle.component',
    'app.googleAdsBidding.component',
    'app.facebookAudience.component',
    'app.snapGender.component',
    'app.advancedDemographics.component',
    'app.pinterestAudience.component',
    'app.customMacrosComponent',
    'app.customMacros2Component',
    'app.seedListMacrosComponent',
    'app.posMatchbackDetailsComponent',
    'app.googleAdsExtension.component',
    'app.tritonAdsFrequencyComponent',
    'app.tritonTeams.component',
    'app.yelpCategories.component',
    'app.linkedinAudience.component',
    'app.snapPredefinedAudiences.component',
    'app.tiktokAudience.component',
    'app.tiktokDevice.component',
    'app.tiktokLanguages.component',
    'app.imageUpload.component',
    'app.linksAndMainCta.component',
    'app.facebookAudiences.component',
    'app.finalApproval.component',
    'app.googleAdManagerAvailUnits.component',
    'app.pinterestGeoLocation.component',
    'app.facebookPageId.component',
    'app.tritonListenerTargeting.component',
    'app.tritonGeoTargeting.component',
    'app.tritonCreativeManagement.component',
    'app.linkedinGeoTargeting.component',
    'app.tritonTimeTargeting.component',
    'app.tritonContentTargeting.component',
    'app.snapchatPixelControls.component',
    'app.pinterestKeyword.component',
    'app.accountabilityGroupLabel.component',
    'app.linkedinCampaignObjective.component',
    'app.tiktokGeoTargeting.component',
    //Core Shared Modules
    'core.shared',
    'schemaForm',
    'ui.sortable',
    'pascalprecht.translate',
    'textAngular',
    'mentio',
    'summernote',
    'ngFileUpload',
    'ngImgCrop',
    'rzModule',
    'gettext',
    /* Additional IOTOOL specific modules */
    'ui.bootstrap',
    'ui.select',
    'ui.sortable',
    'mwl.calendar',
    'angularUtils.directives.dirPagination',
    'colorpicker.module',
    'infinite-scroll',
    'ngEmojiPicker',
    'multi-location-picker',
    'multi-location-picker-fb',
    'dropbox-picker'

])

// Making lodash accetasksFilterssible across the app as well as unit tests
.constant('_', _)

.config(function($sceDelegateProvider) {

    $sceDelegateProvider.resourceUrlWhitelist([
    // Allow same origin resource loads.
    'self',
    // Allow loading from our assets domain. **.
    'https://cdnstaticassets.com/**'
    ]) ;
})

.config(function(paginationTemplateProvider) {
    paginationTemplateProvider.setPath(dirPaginationTplHtmlUrl);
})

// Removes the adding of ng-scope classes used for debugging in Batarang, Protractor and ng-inspector
.config(['$compileProvider', function($compileProvider) {
    var isDevEnv = window.location.pathname.contains('/app/');
    $compileProvider.debugInfoEnabled(isDevEnv);
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|javascript):/);
}])

// Configure loading bar
.config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
    cfpLoadingBarProvider.latencyThreshold = 500;
    cfpLoadingBarProvider.includeSpinner = false;
}])

.config(['$provide', function($provide) {
        $provide.decorator('taOptions', ['taRegisterTool', '$delegate', '$modal', function(taRegisterTool, taOptions, $modal) {
            taOptions.toolbar = [
                ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'quote'],
                ['bold', 'ul', 'ol', 'clear', 'underline'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
                ['html', 'insertImage', 'insertLink', 'insertVideo']
            ];
            return taOptions;
        }]);
    }])
    .config(['DropBoxSettingsProvider', function(DropBoxSettingsProvider) {

        // Configure the options
        DropBoxSettingsProvider.configure({
            linkType: 'preview', //dropbox link type
            multiselect: false, //dropbox multiselect
            extensions: ['.pdf', '.doc', '.docx', ".csv"], //dropbox file extensions
        });
    }])

// Configure restangular

.factory('IORestangular', function(Restangular) {
    return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl('/app/iotool');
    })
})

.factory('CoreRestAngular', function(Restangular) {
    return Restangular.withConfig(function(RestangularConfigurer) {
        RestangularConfigurer.setBaseUrl('/server/api');
    })
})

.config(['RestangularProvider', function(RestangularProvider) {
    RestangularProvider.setBaseUrl('/server/api');
    // add a response intereceptor
    RestangularProvider.addResponseInterceptor(function(data, operation, what, url, response, deferred) {
        var extractedData;
        if (data.metadata) {
            // .. and handle the data and meta data
            extractedData = data.metadata.columns;
        }
        // Since getList expects an array, then we need to wrap
        // result in an array and unwrap using _.first() wherever used
        else if (_.isObject(data) && operation === 'getList') {
            // If sEcho is set then data being returned is for server side datatable
            if (data.data) {
                extractedData = !_.isUndefined(data.data.sEcho) ? [data.data] : _.values(data.data);
            } else {
                extractedData = [data];
            }

            // Add comparison data if any
            if (data.has_comparison_data) {
                extractedData.has_comparison_data = data.has_comparison_data;
            }

            // Add total data if any
            if (data.total_data) {
                // Total data always only contains one item
                extractedData.total_data = _.first(data.total_data);
            }

            // Add extra data if any
            if (data.extra_data) {
                extractedData.extra_data = data.extra_data;
            }
        } else if (data.hasOwnProperty('data')) {
            extractedData = data.data;
        } else {
            extractedData = data;
        }
        return extractedData;
    });

    RestangularProvider.addFullRequestInterceptor(function(element, operation, route, url, headers, params, httpConfig) {
        //This allows to convert the form data to support file uploads
        headers['Content-Type'] = undefined;
        if (!_.isEmpty(element)) {
            var formData = new FormData();
            formData.append('model', angular.toJson(element));
            if (element.files != null) {
                for (var i = 0; i < element.files.length; i++) {
                    formData.append(element.files[i].key, element.files[i]);
                }
            }
        }

        // DEV ONLY - Store all requests to be able to expose them later and replay them
        if (DevTools.isEnabled() && url.contains('/server/api')) {
            // Always return profiler payload in dev mode
            params.sql = 1;
            DevTools.logRequest(url, params);
        }

        return {
            element: formData,
            params: params,
            headers: headers
        };
    });
}])

.config(['$stateProvider', '$urlRouterProvider', 'AppConfig', 'SwitchAppServiceProvider', function($stateProvider, $urlRouterProvider, AppConfig, SwitchAppServiceProvider) {
        var authenticated = ['$q', 'LoginFactory', function($q, LoginFactory) {
            var deferred = $q.defer();
            LoginFactory.isLoggedIn(false)
                .then(function(isLoggedIn) {
                    if (isLoggedIn) {
                        deferred.resolve();
                    } else {
                        deferred.reject('Not logged in');
                    }
                });
            return deferred.promise;
        }];
        // Returns a safe relative path fragment, rejecting anything that could
        // escape the base URL prefix (protocol-relative, absolute URLs, etc.).
        var sanitizeInternalPath = function(url) {
            if (!url || /^(https?:)?\/\//i.test(url)) {
                return '';
            }
            return url;
        };
        var switchApp = ['$stateParams', function($stateParams) {
            var id = sanitizeInternalPath($stateParams.id ? $stateParams.id : '');
            var url = sanitizeInternalPath($stateParams.url ? $stateParams.url : '');
            url += id;
            window.location = AppConfig.TA_URL + '#' + url;

        }];
        var switchIOClientApp = ['$stateParams', function($stateParams) {
            var id = sanitizeInternalPath($stateParams.id ? $stateParams.id : '');
            var url = sanitizeInternalPath($stateParams.url ? $stateParams.url : '');
            url += id;
            window.location = AppConfig.IO_CLIENT_URL + '#' + url;
        }];
        var switchNuiApp = ['$stateParams', '$rootScope', function($stateParams, $rootScope) {
            var id = sanitizeInternalPath($stateParams.id ? $stateParams.id : '');
            var url = sanitizeInternalPath($stateParams.url ? $stateParams.url : '');
            url += id;
            window.location = ($rootScope.user?.user.use_nui  ? AppConfig.NUI_PATH :AppConfig.TA_URL) + '#' + url;
        }];

        $stateProvider
            .state('layout', {
                url: '',
                abstract: true,
                views: {
                    '': {
                        templateUrl: layoutHtmlUrl,
                        controller: 'AppController'
                    },
                    'nav@layout': {
                        templateUrl: AppConfig.MAGE_URL + 'layout/dashleftmenu',
                        controller: 'NavController'
                    },
                    'mainmodals@layout': {
                        templateUrl: AppConfig.MAGE_URL + 'layout/mainmodals'
                    },
                    'footer@layout': {
                        templateUrl: AppConfig.MAGE_URL + 'layout/footer',
                        controller: 'FooterController'
                    }
                },
                resolve: {
                    resolveSettings: ['LoginFactory', function (LoginFactory) {
                        if (!LoginFactory.areUserVarsSet()){
                            return LoginFactory.initUser().then(function (response) {});
                        }
                        return Promise.resolve();
                    }],
                    navItems: function(NavMainResource) {
                        return NavMainResource.getMenuItems();
                    },
                    daterange: function(Restangular) {
                        return Restangular.one('daterange').one('legacy').get();
                    },
                    pages: function(DesignFactory) {
                        // Make sure to load design pages before so that they appear immediately in the nav menu
                        return DesignFactory.getNavPageList();
                    },
                    services: function(ServiceResource) {
                        // Since services are used app-wide, we resolve them at the app level
                        return ServiceResource.getServices();
                    },
                    dataTypes: function(ColumnFactory) {
                        // Since services are used app-wide, we resolve them at the app level
                        return ColumnFactory.dataTypes.get();
                    },
                    relativeDateRanges: function(DateRangeFactory) {
                        // Since relative date ranges are used app-wide, we resolve them at the app level
                        return DateRangeFactory.resource.get();
                    },
                    themeColors: function(UIFactory) {
                        // Since theme colors are used app-wide, we resolve them at the app level
                        return UIFactory.colors.get();
                    },
                    brandMappings: function(Restangular) {
                        return Restangular.all('branding').one('mappings').get();
                    }
                }

            })
            .state('remote_login', {
                url: '/remote_login',
                onEnter: function($state, LoginFactory) {
                    LoginFactory.remoteLogin();
                }
            })
            .state('home', {
                url: '/',
                onEnter: function($state, UserFactory, DesignFactory) {
                    // If we are exporting, we do not want there to be any extra calls or state changes
                    if (!DesignFactory.getIsExportingPage()) {
                        //Need to use UserFactory to get onBoarding state since $scope.user is not present at this point
                        UserFactory.isOnboarding().success(function(json) {
                            if (json.data) {
                                $state.go('service.manage');
                            } else {
                                $state.go('overview');
                            }
                        });
                    }
                }
            })
            //
            //  Tap Analytics redirect states (nav left items)
            //
            //  Following redirects below are manually required since these states come
            //  from the /analytics/ package and aren't imported under IO context
            //
            .state('dashleads', {
                params: {
                    url: '/dash/leads',
                    id: ':id'
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('autoleads', {
                params: {
                    url: '/autoleads'
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('service', {
                params: {
                    url: '/service/details/:id',
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('generatereport', {
                params: {
                    url: '/generatereport'
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('scheduledreports', {
                params: {
                    url: '/scheduledreports'
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('billing', {
                params: {
                    url: '/billing'
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('campaigns', {
                params: {
                    url: '/campaigns'
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('calculations', {
                params: {
                    url: '/calculations'
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('clusters', {
                params: {
                    url: '/clusters'
                },
                resolve: {
                    isTARoute: switchNuiApp
                }
            })
            .state('importwizard', {
                params: {
                    url: '/importwizard'
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('marginrules', {
                params: {
                    url: '/marginrules'
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('preferences', {
                params: {
                    url: '/preferences'
                },
                resolve: {
                    isTARoute: switchNuiApp
                }
            })
            .state('roles', {
                params: {
                    url: '/roles'
                },
                resolve: {
                    isTARoute: switchApp
                }
            })
            .state('io_clientDash', {
                params: {
                    url: '/'
                },
                resolve: {
                    isTARoute: switchIOClientApp
                }
            })
            .state('welcome', {
                params: {
                    url: '/welcome',
                },
                resolve: {
                    isTARoute: switchApp
                }
            });

        $urlRouterProvider.otherwise('/');
    }])
    .run(['$templateCache', function($templateCache) {
        $templateCache.put("directives/decorators/bootstrap/default.html", "<div class=\"schema-form-{{form.type}} {{form.htmlClass}}\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false }\"> <div class=\"form-group\"><label class=\"control-label {{form.labelHtmlClass}}\" ng-class=\"{\'sr-only\': !showTitle()}\" for=\"{{form.key.slice(-1)[0]}}\">{{form.title}}</label> <div class=\"{{form.fieldHtmlClass}}\"><input ng-if=\"!form.fieldAddonLeft && !form.fieldAddonRight\" ng-show=\"form.key\" type=\"{{form.type}}\" step=\"any\" sf-changed=\"form\" placeholder=\"{{form.placeholder}}\" class=\"form-control\" id=\"{{form.key.slice(-1)[0]}}\" ng-model-options=\"form.ngModelOptions\" ng-model=\"$$value$$\" ng-disabled=\"form.readonly\" schema-validate=\"form\" name=\"{{form.key.slice(-1)[0]}}\" aria-describedby=\"{{form.key.slice(-1)[0] + \'Status\'}}\"><div class=\"help-block\" sf-message=\"form.description\"></div></div><div ng-if=\"form.fieldAddonLeft || form.fieldAddonRight\" ng-class=\"{\'input-group\': (form.fieldAddonLeft || form.fieldAddonRight)}\"><span ng-if=\"form.fieldAddonLeft\" class=\"input-group-addon\" ng-bind-html=\"form.fieldAddonLeft\"></span> <input ng-show=\"form.key\" type=\"{{form.type}}\" step=\"any\" sf-changed=\"form\" placeholder=\"{{form.placeholder}}\" class=\"form-control {{form.fieldHtmlClass}}\" id=\"{{form.key.slice(-1)[0]}}\" ng-model-options=\"form.ngModelOptions\" ng-model=\"$$value$$\" ng-disabled=\"form.readonly\" schema-validate=\"form\" name=\"{{form.key.slice(-1)[0]}}\" aria-describedby=\"{{form.key.slice(-1)[0] + \'Status\'}}\"> <span ng-if=\"form.fieldAddonRight\" class=\"input-group-addon\" ng-bind-html=\"form.fieldAddonRight\"></span><div class=\"help-block\" sf-message=\"form.description\"></div><span ng-if=\"form.feedback !== false\" class=\"form-control-feedback\" ng-class=\"evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\" aria-hidden=\"true\"></span> <span ng-if=\"hasError() || hasSuccess()\" id=\"{{form.key.slice(-1)[0] + \'Status\'}}\" class=\"sr-only\">{{ hasSuccess() ? \'(success)\' : \'(error)\' }}</span></div></div></div>");
        $templateCache.put("directives/decorators/bootstrap/section.html", "<div class=\"{{form.containerClass}}\"><div class=\"schema-form-section {{form.htmlClass}}\"><div ng-if=\"form.sectionTitle\" class=\"main-content-title\"><p class=\"main-title\">{{form.sectionTitle}}</p></div><sf-decorator ng-repeat=\"item in form.items\" form=\"item\"></sf-decorator></div></div>");
        $templateCache.put("directives/decorators/bootstrap/select.html", "<div class=\"{{form.htmlClass}} schema-form-select\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess(), \'has-feedback\': form.feedback !== false}\"><div class=\"form-group\"><label class=\"control-label {{form.labelHtmlClass}}\" ng-show=\"showTitle()\">{{form.title}}</label><div class=\"{{form.fieldHtmlClass}}\"><select ng-model=\"$$value$$\" ng-model-options=\"form.ngModelOptions\" ng-disabled=\"form.readonly\" sf-changed=\"form\" class=\"form-control\" schema-validate=\"form\" ng-options=\"item.value as item.name group by item.group for item in form.titleMap\" name=\"{{form.key.slice(-1)[0]}}\"></select><div class=\"help-block help-text\" sf-message=\"form.description\"></div></div></div></div>");
        $templateCache.put("directives/decorators/bootstrap/textarea.html", "<div class=\"has-feedback {{form.htmlClass}} schema-form-textarea\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}\"><div class=\"form-group\"><label class=\"control-label {{form.labelHtmlClass}}\" ng-class=\"{\'sr-only\': !showTitle()}\" for=\"{{form.key.slice(-1)[0]}}\">{{form.title}}</label><div class=\"{{form.fieldHtmlClass}}\"> <textarea ng-if=\"!form.fieldAddonLeft && !form.fieldAddonRight\" class=\"form-control\" id=\"{{form.key.slice(-1)[0]}}\" sf-changed=\"form\" placeholder=\"{{form.placeholder}}\" ng-disabled=\"form.readonly\" ng-model=\"$$value$$\" ng-model-options=\"form.ngModelOptions\" schema-validate=\"form\" name=\"{{form.key.slice(-1)[0]}}\"></textarea><span class=\"help-block\" sf-message=\"form.description\"></span></div></div></div>");
        $templateCache.put("directives/decorators/bootstrap/checkbox.html", "<div class=\"schema-form-checkbox {{form.htmlClass}}\" ng-class=\"{\'has-error\': form.disableErrorState !== true && hasError(), \'has-success\': form.disableSuccessState !== true && hasSuccess()}\"><div class=\"form-group\"><label class=\" control-label {{form.labelHtmlClass}}\">{{form.title}}</label><div class=\"{{form.fieldHtmlClass}}\"><input type=\"checkbox\" sf-changed=\"form\" ng-disabled=\"form.readonly\" ng-model=\"$$value$$\" ng-model-options=\"form.ngModelOptions\" schema-validate=\"form\" name=\"{{form.key.slice(-1)[0]}}\"><div class=\"help-block\" sf-message=\"form.description\"></div></div></div></div>");
        $templateCache.put("directives/decorators/bootstrap/uiselect/single.html", "<div class=\"{{form.htmlClass}}\" ng-class=\"{\'has-error\': hasError(), \'has-success\': hasSuccess(), \'has-feedback\': form.feedback !== false}\" ng-init=\"select_models=(form.schema.items | where : {value: $$value$$})\">\n <div class=\"form-group\"> <label class=\"control-label {{form.labelHtmlClass}}\" ng-show=\"showTitle()\">{{form.title}}</label>\n  <div class=\"{{form.fieldHtmlClass}}\" ng-init=\"select_model.selected=select_models[0]\">\n    <ui-select ng-model=\"select_model.selected\" ng-controller=\"UiSelectController\"  ng-if=\"!(form.options.tagging||false)\" theme=\"bootstrap\" ng-disabled=\"form.disabled\" on-select=\"$$value$$=$item.value\" class=\"{{form.options.uiClass}}\">\n      <ui-select-match placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\' | translate)}}\">{{select_model.selected.label}}</ui-select-match>\n      <ui-select-choices refresh=\"fetchResult(form.schema, form.options, $select.search)\"\n             refresh-delay=\"form.options.refreshDelay\" group-by=\"form.options.groupBy\"  repeat=\"item in form.schema.items | propsFilter: {label: $select.search, description: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n                <div ng-bind-html=\"item.label | highlight: $select.search\"></div>\n      <div ng-if=\"item.description\"> \n        <span ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\'))+ \'</small>\'\"></span></div>\n      </ui-select-choices>\n    </ui-select>\n    <ui-select ng-controller=\"UiSelectController\"  ng-model=\"select_model.selected\" ng-if=\"(form.options.tagging||false) && !(form.options.groupBy || false)\" tagging=\"form.options.tagging||false\" tagging-label=\"form.options.taggingLabel\" tagging-tokens=\"form.options.taggingTokens\"\n      theme=\"bootstrap\" ng-disabled=\"form.disabled\" on-select=\"$$value$$=$item.value\" class=\"{{form.options.uiClass}}\">\n      <ui-select-match placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\' | translate)}}\">{{select_model.selected.label}}&nbsp;<small>{{(select_model.selected.isTag===true ? form.options.taggingLabel : \'\')}}</small></ui-select-match>\n      <!--repeat code because tagging does not display properly under group by but is still useful -->\n      <ui-select-choices  refresh=\"form.options.refreshMethod(form.schema, $select.search)\"\n             refresh-delay=\"form.options.refreshDelay\" repeat=\"item in form.schema.items | propsFilter: {label: $select.search, description: (form.options.searchDescription===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n        <div ng-if=\"item.isTag\" ng-bind-html=\"\'<div>\' + (item.label   | highlight: $select.search) + \' \' + form.options.taggingLabel + \'</div><div class=&quot;divider&quot;></div>\'\"></div><div ng-if=\"!item.isTag\" ng-bind-html=\"item.label + item.isTag| highlight: $select.search\"></div>\n      <div ng-if=\"item.description\"> \n        <span  ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\')) + \'</small>\'\"></span>\n      </div>\n    </ui-select-choices>\n    </ui-select>\n\n      <!--repeat code because tagging does not display properly under group by but is still useful -->\n\n    <ui-select ng-controller=\"UiSelectController\"  ng-model=\"select_model.selected\" ng-if=\"(form.options.tagging||false) && (form.options.groupBy || false)\"  tagging=\"form.options.tagging||false\" tagging-label=\"form.options.taggingLabel\" tagging-tokens=\"form.options.taggingTokens\"\n      theme=\"bootstrap\" ng-disabled=\"form.disabled\" on-select=\"$$value$$=$item.value\" class=\"{{form.options.uiClass}}\">\n      <ui-select-match placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\' | translate)}}\">{{select_model.selected.label}}&nbsp;<small>{{(select_model.selected.isTag===true ? form.options.taggingLabel : \'\')}}</small></ui-select-match>\n      <ui-select-choices group-by=\"form.options.groupBy\" refresh=\"form.options.refreshMethod(form.schema, $select.search)\"\n             refresh-delay=\"form.options.refreshDelay\" repeat=\"item in form.schema.items | propsFilter: {label: $select.search, description: (form.options.searchDescription===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n        <div ng-if=\"item.isTag\" ng-bind-html=\"\'<div>\' + (item.label   | highlight: $select.search) + \' \' + form.options.taggingLabel + \'</div><div class=&quot;divider&quot;></div>\'\"></div><div ng-if=\"!item.isTag\" ng-bind-html=\"item.label + item.isTag| highlight: $select.search\"></div>\n      <div ng-if=\"item.description\"> \n        <span  ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\')) + \'</small>\'\"></span>\n      </div>\n    </ui-select-choices>\n    </ui-select>\n    <input type=\"hidden\" toggle-single-model sf-changed=\"form\" ng-model=\"insideModel\" schema-validate=\"form\" />\n    <span ng-if=\"form.feedback !== false\"\n      class=\"form-control-feedback\"\n      ng-class=\"evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\"></span>\n    <div class=\"help-block\"\n      ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\"\n      ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div>\n </div>\n </div>\n</div>\n");
        $templateCache.put("directives/decorators/bootstrap/uiselect/multi.html", "<div class=\"{{form.htmlClass}}\" ng-class=\"{\'has-error\': hasError(), \'has-success\': hasSuccess(), \'has-feedback\': form.feedback !== false}\" ng-init=\"form.select_models=(form.schema.items| whereMulti : \'value\' : ($$value$$||[]))\">\n <div class=\"form-group\"> <label class=\"control-label {{form.labelHtmlClass}}\" ng-show=\"showTitle()\">{{form.title}}</label>\n  <div class=\"{{form.fieldHtmlClass}}\" ng-controller=\"UiSelectController\">\n    <ui-select ui-select-no-animate tagging=\"tagHandler\" multiple close-on-select=\"false\" sortable-options=\"{{form.sortableOptions}}\" ng-if=\"!(form.options.tagging||false)\" array-required=\"{{form.isRequired}}\" ng-model=\"form.select_models\" theme=\"bootstrap\" on-select=\"$$value$$.push($item.value)\" on-remove=\"$$value$$.splice($$value$$.indexOf($item.value), 1)\" class=\"{{form.options.uiClass}}\">\n      <ui-select-match placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\' | translate)}}\">{{$item.label}}</ui-select-match>\n      <ui-select-choices refresh=\"fetchResult(form.schema, form.options, $select.search)\"\n         refresh-delay=\"form.options.refreshDelay\" group-by=\"form.options.groupBy\"  repeat=\"item in form.schema.items | propsFilter: {label: $select.search, description: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n        <div ng-bind-html=\"item.label | highlight: $select.search\"></div>\n        <div ng-if=\"item.description\">\n          <span ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\'))+ \'</small>\'\"></span>\n        </div>\n    </ui-select-choices>\n    </ui-select>\n    <ui-select ng-controller=\"UiSelectController\" multiple ng-if=\"(form.options.tagging||false) && !(form.options.groupBy || false)\" tagging=\"form.options.tagging||false\" tagging-label=\"form.options.taggingLabel\" tagging-tokens=\"form.options.taggingTokens\" sortable-options=\"{{form.sortableOptions}}\" array-required=\"{{form.isRequired}}\" ng-model=\"form.select_models\" theme=\"bootstrap\" on-select=\"$$value$$.push($item.value)\" on-remove=\"$$value$$.splice($$value$$.indexOf($item.value), 1)\" class=\"{{form.options.uiClass}}\">\n      <ui-select-match placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\' | translate)}}\">{{$item.label}}&nbsp;<small>{{($item.isTag===true ?  form.options.taggingLabel : \'\')}}</small></ui-select-match>\n      <ui-select-choices  refresh-delay=\"form.options.refreshDelay\" refresh=\"fetchResult(form.schema, form.options, $select.search)\"\n         refresh-delay=\"form.options.refreshDelay\" repeat=\"item in form.schema.items | propsFilter: {label: $select.search, description: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n          <div ng-if=\"item.isTag\" ng-bind-html=\"\'<div>\' + (item.label   | highlight: $select.search) + \' \' + form.options.taggingLabel + \'</div><div class=&quot;divider&quot;></div>\'\"></div>\n          <div ng-if=\"!item.isTag\" ng-bind-html=\"item.label + item.isTag | highlight: $select.search\"></div>\n      <div ng-if=\"item.description\"> \n        <span ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\')) + \'</small>\'\"></span>\n      </div>\n    </ui-select-choices>\n      <!--repeat code because tagging does not display properly under group by but is still useful -->\n    </ui-select>\n\n    <ui-select ng-controller=\"UiSelectController\" multiple ng-if=\"(form.options.tagging||false) && (form.options.groupBy || false)\" tagging=\"form.options.tagging||false\" tagging-label=\"form.options.taggingLabel\" tagging-tokens=\"form.options.taggingTokens\" sortable-options=\"{{form.sortableOptions}}\" array-required=\"{{form.isRequired}}\" ng-model=\"form.select_models\" theme=\"bootstrap\" on-select=\"$$value$$.push($item.value)\" on-remove=\"$$value$$.splice($$value$$.indexOf($item.value), 1)\" class=\"{{form.options.uiClass}}\">\n      <ui-select-match placeholder=\"{{form.placeholder || form.schema.placeholder || (\'placeholders.select\' | translate)}}\">{{$item.label}}&nbsp;<small>{{($item.isTag===true ?  form.options.taggingLabel : \'\')}}</small></ui-select-match>\n      <ui-select-choices group-by=\"form.options.groupBy\" refresh-delay=\"form.options.refreshDelay\" refresh=\"fetchResult(form.schema, form.options, $select.search)\"\n         refresh-delay=\"form.options.refreshDelay\" repeat=\"item in form.schema.items | propsFilter: {label: $select.search, description: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\') }\">\n          <div ng-if=\"item.isTag\" ng-bind-html=\"\'<div>\' + (item.label   | highlight: $select.search) + \' \' + form.options.taggingLabel + \'</div><div class=&quot;divider&quot;></div>\'\"></div>\n          <div ng-if=\"!item.isTag\" ng-bind-html=\"item.label + item.isTag | highlight: $select.search\"></div>\n      <div ng-if=\"item.description\"> \n        <span ng-bind-html=\"\'<small>\' + (\'\'+item.description | highlight: (form.options.searchDescriptions===true ? $select.search : \'NOTSEARCHINGFORTHIS\')) + \'</small>\'\"></span>\n      </div>\n    </ui-select-choices>\n\n    </ui-select>\n    <input toggle-model type=\"hidden\" ng-model=\"insideModel\" sf-changed=\"form\" schema-validate=\"form\" />\n    <span ng-if=\"form.feedback !== false\"\n      class=\"form-control-feedback\"\n      ng-class=\"evalInScope(form.feedback) || {\'glyphicon\': true, \'glyphicon-ok\': hasSuccess(), \'glyphicon-remove\': hasError() }\"></span>\n    <div class=\"help-block\"\n      ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\"\n      ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div>\n  </div>\n</div>\n");
        $templateCache.put("directives/decorators/bootstrap/submit.html", "<div class=\"form-group schema-form-submit {{form.htmlClass}}\"><input type=\"submit\" class=\"btn {{ form.style || \'btn-primary\' }} {{form.fieldHtmlClass}}\" value=\"{{form.title}}\" ng-disabled=\"form.readonly\" ng-if=\"form.type === \'submit\'\"> <button class=\"btn {{ form.style || \'btn-default\' }}\" type=\"button\" ng-click=\"buttonClick($event,form)\" ng-disabled=\"form.readonly || form.isSubmitted\" ng-if=\"form.type !== \'submit\'\"><span ng-if=\"form.icon\" class=\"{{form.icon}}\"></span> {{form.title}}</button></div>");
    }])

.run([
    '$rootScope',
    '$state',
    '$timeout',
    '$templateCache',
    'AppConfig',
    'CoreFactory',
    'LoginFactory',
    'NavigationService',
    'CurrentUser',
    'UserLoginFactory',
    'UserFactory',
    '$ioAlert',
    '$http',
    function(
        $rootScope,
        $state,
        $timeout,
        $templateCache,
        AppConfig,
        CoreFactory,
        LoginFactory,
        NavigationService,
        CurrentService,
        UserLoginFactory,
        UserFactory,
        $ioAlert,
        $http
    ) {

        $rootScope.$on('$stateChangeError', function() {
            if (performance.now() - (window.lastLoginRedirect ?? 0) > 200) {
                window.lastLoginRedirect = performance.now();
                // Redirect user to our login page
                $state.go('login');
            }
        });

        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            NavigationService.addPath(toState, toParams, fromState, fromParams);

            if (toState.name !== 'login' &&
                toState.name !== 'remote_login') {
                UserLoginFactory.setIntendedState(toState.name, toParams);
                UserLoginFactory.setUrl(window.location);
            }

            if (typeof dataLayer != 'undefined') {
                window.dataLayer.push({
                    currentUrl: window.location.href,
                    destination: toState.url,
                    event: 'stateChange'
                });
            }

            //This clears non-persisted datatables from the oTables object array
            $.core.datatable.resetTables();
        });

        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams) {

            //Check if overview which is home state else use state name
            var viewName = toState.name;
            var viewId = toParams.id;

            $timeout(function() {
                if($rootScope.userRole && !NavigationService.isAuthorisedStateName($rootScope.userRole, toState)){
                    $ioAlert.show('Error!', 'You are not allowed to access this page!', 'error');
                    $state.go('forbiddenPage');
                    return false;
                }
                var $body = $('body');
                var $rightFrame = $('#right-frame');

                Main.hideAjaxMainLoading();
                Main.highlightCurrentNavMenu(viewName, viewId);

                $rightFrame.focus(); //Allow user to scroll using arrow keys

                $('.tooltip').tooltip('hide');
                Main.tooltip($rightFrame);

                //Ensure that when we load a new state/page, we are at the top of the screen
                $rightFrame.scrollTop(0);


                // Apply proper offset if viewing as impersonated user
                if ($rootScope.user.isImpersonationMode) {
                    $body.addClass('impersonation-mode io-impersonation');
                } else {
                    $body.removeClass('impersonation-mode io-impersonation');
                }
            });
        });

        //Legacy root url support for $.fn.actionUrl for the magento api url 'app/dash' (for IOTOOL)
        $.globals.utils.rootUrl = AppConfig.MAGE_URL;
        $.globals.utils.appUrl = AppConfig.ROOT_URL;
        $.globals.utils.apiUrl = AppConfig.API_URL;
        $.globals.utils.taUrl = AppConfig.TA_URL;
        $.globals.utils.ioUrl = AppConfig.IO_URL;

        // @todo: SHOULD BE REPLACED AND DEPRECATED
        // Allows data to be bubbled and set up the two-way binding tree
        $rootScope.safeApply = function(fn) {
            var phase = this.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                if (fn && (typeof(fn) === 'function')) {
                    fn();
                }
            } else {
                this.$apply(fn);
            }
        };

        // This function should be used for safe applying since it uses the
        // passed scoped which isn't as lazy as the one above
        $rootScope.scopeApply = function(scope, fn) {
            (scope.$$phase || scope.$root.$$phase) ? fn(): scope.$apply(fn);
        };

        //App util functions (needed for TA session service)
        $rootScope.util = {
            mageUrl: function(path) {
                path = angular.isUndefined(path) ? '' : path;
                return AppConfig.MAGE_URL + path;
            },
            apiUrl: function(path) {
                path = angular.isUndefined(path) ? '' : path;
                return AppConfig.API_URL + path;
            },
            isFeatureAvailable: function($featureName) {
                return $rootScope.user.availableFeatures && $rootScope.user.availableFeatures.contains($featureName);
            },
            isModuleAvailable: function($moduleName) {
                return $rootScope.user.availableModules && $rootScope.user.availableModules.contains($moduleName);
            }
        };

        // Handle OAuth request forwarded from Analytics App.
        var isAllowedOAuthRedirect = function(url) {
            if (!url) return false;
            try {
                var parsed = new URL(url);
                var allowed = [window.location.hostname, 'im.tapanalytics.com', 'im.tapclicks.com', 'im.tapdemo.com'];
                return allowed.indexOf(parsed.hostname) !== -1;
            } catch (e) {
                return false;
            }
        };
        if (window.localStorage.getItem('oauth_request')) {
            const oauthParams = JSON.parse(window.localStorage.getItem('oauth_request'));

            if (!_.isUndefined(oauthParams.oauth_client_id) && !_.isUndefined(oauthParams.oauth_redirect_uri)
                    && isAllowedOAuthRedirect(oauthParams.oauth_redirect_uri)) {
                // set OAuth information globally
                oAuth.clientId = oauthParams.oauth_client_id;
                oAuth.redirect = oauthParams.oauth_redirect_uri;
                oAuth.icon = !_.isUndefined(oauthParams.oauth_icon) ? oauthParams.oauth_icon : null;
                oAuth.state = !_.isUndefined(oauthParams.oauth_state) ? oauthParams.oauth_state : null;

                // Process the OAuth request
                LoginFactory.getOAuthAuthorizationCode();
            }
            window.localStorage.removeItem('oauth_request');
        }

        //Initialize the user with some backend data (this occurs before login as well)
        $rootScope.user = {};

        UserFactory.updateAppPreference({use_nui: false});
        LoginFactory.initUser().then(async (json) => {
            if (!json.data.settings.isIOAuthorized && !_.includes(['superadmin', 'cluster_admin'], json.data.settings.user.user_type)) {
                $ioAlert.show('Error!', 'You are not allowed to access this page!', 'error');
                $state.go('welcome');
                return false;
            }
        });

        // IO-specific user settings
        $rootScope.userRole = {};
        CurrentService.get();

        $http.get(appHeaderUrl).then(response => {
            $templateCache.put('app_header.html', response.data);
        })
    }
]);
